import { useQuery } from '@apollo/client';
import type { Option } from '@openx/types/options';
import { useMemo } from 'react';
import { GetOrganizationsListDocument } from '../../../graphql/query/organizations/GetOrganizationsList.generated';

export const useAccountOptionsFetch = () => {
  const { data, error, loading } = useQuery(GetOrganizationsListDocument);

  const mapById = useMemo(() => {
    if (!data?.account) {
      return {};
    }

    return data?.account.reduce<Record<string, Option>>((acc, option) => {
      if (option?.exchange_account_network) {
        acc[option.exchange_account_network.uid] = { id: option.exchange_account_network.uid, name: option.name };
      }

      return acc;
    }, {});
  }, [data]);

  return {
    isError: !!error,
    isLoading: loading,
    mapById,
  };
};
